import queryString from 'query-string';

/*export const urlify = text => {
    if (!text) {
        return text;
    }

    if (typeof text !== "string") {
        throw new Error("O tipo do parâmetro text deve ser string, recebido " + typeof text + ".");
    }

    // Este "<" na expressão regular não funciona no Firefox.
    var urlRegex = /(https?:\/\/[^\s]+)(?<!(\.)|(\´)|(\,)|(\;))/g;

    return text.replace(urlRegex, url => {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
    });
};*/

export const getUniqueObjectArrayById = (arr, key = 'id') => {
    if (typeof arr !== "object") {
        throw new Error("O tipo do parâmetro arr deve ser object, recebido " + typeof arrArg + ".");
    }

    const map = new Map();

    arr.map(el => {
        if (!map.has(el[key])) {
            map.set(el[key], el);
        }
    });

    return [...map.values()];
};

export const removeSpecialCharacter = str => {
    if (!str) {
        return str;
    }

    if (typeof str !== "string") {
        throw new Error("O tipo do parâmetro str deve ser string, recebido " + typeof str + ".");
    }

    const special = "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ";
    const noSpecial = "AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr";

    let newValue = "";

    for (let i = 0; i < str.length; i++) {
        let flag = false;

        for (let a = 0; a < special.length; a++) {
            if (str.substr(i, 1) == special.substr(a, 1)) {
                newValue += noSpecial.substr(a, 1);

                flag = true;

                break;
            }
        }

        if (!flag) {
            newValue += str.substr(i, 1);
        }
    }

    return newValue;
};

export const replaceTextToBold = (text, sub) => {
    if (!text) {
        return text;
    }

    if (typeof text !== "string") {
        throw new Error("O tipo do parâmetro text deve ser string, recebido " + typeof text + ".");
    }

    if (sub !== null && typeof sub !== "undefined" && typeof sub !== "string") {
        throw new Error("O tipo do parâmetro sub deve ser string, recebido " + typeof sub + ".");
    }

    if (sub !== '') {
        const regEx = new RegExp(sub, 'ig');

        return text.replace(regEx, (match, offset, string) => {
            return '<b>' + match + '</b>';
        });
    }

    return text;
};

export const commaSeparate = (textArray = []) => {
    let finalText = '';

    for (let i = 0; i < textArray.length; i++) {
        const text = textArray[i];

        if (i === textArray.length - 1) {
            finalText += text;
        } else {
            finalText += text + ', ';
        }
    }

    return finalText;
};

export const isInvalidDate = (dateString, numberValidDays) => {
    if (typeof dateString !== "string") {
        throw new Error("O tipo do parâmetro dateString deve ser string, recebido " + typeof dateString + ".");
    }

    if (!numberValidDays) {
        return false;
    }

    const day = dateString.substr(0, 2);
    const month = dateString.substr(3, 2);
    const year = dateString.substr(6, 4);
    const hour = dateString.substr(11);

    let dateParameter = new Date(month + "/" + day + "/" + year + " " + hour);
    dateParameter.setDate(dateParameter.getDate() + numberValidDays);

    const dateToday = new Date();

    return dateToday > dateParameter;
};

export const truncate = (input, lenght = 45) => {
    if (input.length > lenght)
        return input.substring(0, lenght) + '...';
    else
        return input;
};

export const isIOS = () => {
    return process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
};

export const toDate = dateStr => {
    const parts = dateStr.split('/');

    return new Date(parts[2], parts[1] - 1, parts[0]);
};

export const toHour = hourStr => {
    const parts = hourStr.split(':');

    const date = new Date();
    date.setHours(parts[0]);
    date.setMinutes(parts[1]);

    return date;
};

export const toDateWithHour = dateStr => {
    if (dateStr && dateStr !== '-') {
        const parts = dateStr.trim().split(' ');

        const part1 = parts[0].split('/');
        const part2 = parts[1].split(':');

        return new Date(part1[2], part1[1] - 1, part1[0], part2[0], part2[1]);
    } else {
        return new Date();
    }
};

export const formatDate = (date = new Date()) => {
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return day.toString().padStart(2, '0') + '/' + (monthIndex + 1).toString().padStart(2, '0') + '/' + year;
};

export const formatHour = (date = new Date()) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
};

export const getCurrentYear = () => {
    return new Date().getFullYear();
};

export const normalize = (value, min, max) => (value - min) * 100 / (max - min);

export const createUrlParamsIds = ids => {
    const params = new URLSearchParams();

    ids.map(id => params.append('id', id));

    return params.toString();
};

export const downloadFile = (url, fileName = 'download') => {
    const a = document.createElement("a");

    document.body.appendChild(a);

    a.style.display = 'none';
    a.href = url;
    a.setAttribute('download',fileName);

    a.click();
};

export const getBrowserInfo = () => {
    let ua = navigator.userAgent, tem, M = ua.match(/(edge|opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)	|| [];

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];

        return {
            name : 'IE',
            version : (tem[1] || '')
        };
    }

    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);

        if (tem != null) {
            return {
                name : 'Opera',
                version : tem[1]
            };
        }

        tem = ua.match(/\bEdge\/(\d+)/);

        if (tem != null) {
            return {
                name : 'Edge',
                version : tem[1]
            };
        }
    }

    M = M[2] ? [ M[1], M[2] ] : [ navigator.appName, navigator.appVersion, '-?' ];

    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }

    return {
        name : M[0],
        version : M[1]
    };
};

export const queryStringParsed = (decode = false) => {
    return queryString.parse(location.search, { decode });
};

export const formatByteValue = bytes => {
    if (bytes > 1024 * 1024 * 1024) {
        return Math.round(bytes / (1024 * 1024 * 1024)) + 'GB';
    }

    if (bytes > 1024 * 1024) {
        return Math.round(bytes / (1024 * 1024)) + 'MB';
    }

    if (bytes > 1024) {
        return Math.round(bytes / 1024) + 'KB';
    }

    return bytes + 'B';
};

export const padNumber = (num, size) => {
    num = num.toString();

    while (num.length < size) num = "0" + num;

    return num;
};

export const removeSpecialCharacter2 = palavra => {
    var caractereEspeciais = '-_.';

    for (let l in palavra){
        for (let l2 in caractereEspeciais){
            if (palavra[l] == caractereEspeciais[l2]){
                palavra = palavra.replace(palavra[l], "");
            }
        }
    }

    return palavra;
};

export const validateCPF = strCPF => {
    if (strCPF.indexOf(".") > -1 || strCPF.indexOf("-") > -1) {
        strCPF = removeSpecialCharacter2(strCPF);
    }

    let Soma;
    let Resto;

    Soma = 0;

    if (strCPF == "00000000000"
            || strCPF == "11111111111"
            || strCPF == "22222222222"
            || strCPF == "33333333333"
            || strCPF == "44444444444"
            || strCPF == "55555555555"
            || strCPF == "66666666666"
            || strCPF == "77777777777"
            || strCPF == "88888888888"
            || strCPF == "99999999999")
        return false;

    if (strCPF.length < 11) {
        strCPF = "0" + strCPF;
    }

    for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))
        Resto = 0;

    if (Resto != parseInt(strCPF.substring(9, 10)) )
        return false;

    Soma = 0;

    for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))
        Resto = 0;

    if (Resto != parseInt(strCPF.substring(10, 11)))
        return false;

    return true;
};

export const validateCNPJ = cnpj => {
    cnpj = cnpj.replace(/[^\d]+/g,'');

    if(cnpj == '') return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado != digitos.charAt(1))
        return false;

    return true;
};

export const validateEmail = email => {
    let usuario = email.substring(0, email.indexOf("@"));
    let dominio = email.substring(email.indexOf("@") + 1, email.length);

    if ((usuario.length >= 1) && (dominio.length >= 3) && (usuario.search("@") == -1)
        && (dominio.search("@") == -1) && (usuario.search(" ") == -1)
        && (dominio.search(" ") == -1) && (dominio.search(".") != -1)
        && (dominio.indexOf(".") >= 1) && (dominio.lastIndexOf(".") < dominio.length - 1)) {
        return true;
    } else {
        return false;
    }
};

export const calculateAge = dataNascimento => {
    let birthMonth = dataNascimento.substring(3, 5);
    let birthDay = dataNascimento.substring(0, 2);
    let birthYear = dataNascimento.substring(6, 10);
    let todayDate = new Date();
    let todayYear = todayDate.getFullYear();
    let todayMonth = todayDate.getMonth();
    let todayDay = todayDate.getDate();

    let age = todayYear - birthYear;

    if (todayMonth < birthMonth - 1){
        age--;
    }

    if (birthMonth - 1 === todayMonth && todayDay < birthDay) {
        age--;
    }

    return age;
};

export const dateInFull = () => {
    const meses = new Array("Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro");
    const semana = new Array("Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado");

    const hoje = new Date();
    const dia = hoje.getDate();
    const mes = hoje.getMonth();
    let ano = hoje.getYear();

    if (navigator.appName === "Netscape") {
        ano = ano + 1900;
    }

    return dia + " de " + meses[mes] + " de " + ano;
};

export const formatCurrency = number => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);
};

export const fillFormikFields = (formik, object) => {
    Object.entries(object).map(([key, value]) => {
        formik.setFieldValue(key, value, false);
    });
}

export const fillReactHookFormFields = (setValue, object) => {
    Object.entries(object).map(([key, value]) => {
        setValue(key, value);
    });
}